<template>
  <div class="payment-complete-page">
    <div class="payment-complete-card">
      <template v-if="cancelled">
        <h1>Payment not completed</h1>
        <p>
          No problem — your registration has still been saved. You can arrange
          payment with the club later.
        </p>
      </template>

      <template v-else-if="confirming">
        <h1>Checking your payment…</h1>
        <p>One moment while we confirm your payment with Stripe.</p>
      </template>

      <template v-else-if="confirmedStatus === 'active' || confirmedStatus === 'paid'">
        <h1>Payment set up 🎉</h1>
        <p>
          {{
            confirmedStatus === "active"
              ? "Your membership subscription is now active."
              : "Your fee has been paid."
          }}
          A receipt has been emailed to you by Stripe.
        </p>
      </template>

      <template v-else>
        <h1>Payment pending</h1>
        <p>
          We couldn't confirm the payment yet. If you completed the Stripe
          page, the club will see it shortly — otherwise the club will be in
          touch about payment.
        </p>
      </template>

      <div class="actions">
        <router-link class="green-button" to="/login">Go to login</router-link>
        <router-link
          v-if="siblingRegisterLink"
          class="sibling-link"
          :to="siblingRegisterLink"
        >
          <i class="bi bi-person-plus"></i> Register another child
        </router-link>
      </div>
      <p class="sibling-hint" v-if="siblingRegisterLink">
        Registering another child? Use the same email and password — you'll be
        able to switch between your children from one login.
      </p>
    </div>
  </div>
</template>

<script>
import { StripeConnect } from "@/services/stripe-connect-service.js";

export default {
  name: "RegistrationPaymentComplete",
  data() {
    return {
      confirming: true,
      confirmedStatus: null,
    };
  },
  computed: {
    cancelled() {
      return this.$route.params.sessionId === "cancelled";
    },
    // Offered when the register page stashed family details for this club
    // (sessionStorage survives the round-trip to Stripe Checkout)
    siblingRegisterLink() {
      try {
        const raw = sessionStorage.getItem("grassrootsFamilyPrefill");
        if (!raw) return null;
        const prefill = JSON.parse(raw);
        if (!prefill.clubId || prefill.clubId !== this.$route.query.clubId) {
          return null;
        }
        return `/register/${encodeURIComponent(prefill.clubId)}?sibling=1`;
      } catch (error) {
        return null;
      }
    },
  },
  async created() {
    if (this.cancelled) {
      this.confirming = false;
      return;
    }
    try {
      const response = await StripeConnect.confirmCheckoutSession(
        this.$route.query.clubId,
        this.$route.params.sessionId,
      );
      this.confirmedStatus = response.data.data.status;
    } catch (error) {
      this.confirmedStatus = null;
    } finally {
      this.confirming = false;
    }
  },
};
</script>

<style scoped lang="scss">
.payment-complete-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f6f8;
  padding: 1rem;

  .payment-complete-card {
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    padding: 2.5rem;
    max-width: 480px;
    text-align: center;

    h1 {
      font-size: 1.5rem;
      margin-bottom: 0.75rem;
    }

    p {
      color: #555;
      margin-bottom: 1.5rem;
    }

    .green-button {
      display: inline-block;
      text-decoration: none;
    }

    .actions {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.75rem;
    }

    .sibling-link {
      color: #1e87f0;
      text-decoration: none;
      font-size: 0.95rem;
    }

    .sibling-hint {
      margin-top: 1rem;
      font-size: 0.85rem;
      color: #777;
    }
  }
}
</style>
